import getNumberFromLocaleString from './getNumberFromLocaleString';
import getNumberSeparatorsFromLocale from '../../../../localeUtils/getNumberSeparatorsFromLocale';
import {Locale} from '../../../../RootProvider/LocaleContext';

const handleChange =
  (name: string, locale: Locale, cb: (name: string, value: string | number) => void) =>
  (event: React.ChangeEvent<HTMLInputElement>): void => {
    const {decimalSeparator} = getNumberSeparatorsFromLocale(locale);

    const inputValue = event.target.value;
    if (inputValue === '') {
      cb(name, '');
      return;
    }

    const lastInputChar = inputValue[inputValue.length - 1];
    if (lastInputChar === decimalSeparator && inputValue.length > 1) {
      // if it ends in a decimalSeparator, and it is not just a . or ,
      // then pass up as a . at the end of the formatted number
      const formattedValue = `${getNumberFromLocaleString(inputValue, locale).toString()}.`;
      cb(name, formattedValue);
      return;
    }

    if (Number.isNaN(parseInt(lastInputChar, 10))) {
      // ignore if it's a character that's not a number
      return;
    }

    // pass up the value as a number type
    const formattedValue = getNumberFromLocaleString(inputValue, locale);
    cb(name, formattedValue);
  };

export default handleChange;
